import { Redirect, Route } from "react-router-dom";

const AuthProtected = (props) => {
    const token = (!sessionStorage.getItem("token")) ? null : sessionStorage.getItem("token");
    if(token === "" || token === null || typeof(token) === "undefined"){
        return(
            <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        );
    }
    return <>{props.children}</>
};

const AccessRoute = ({ component: Component, ...rest }) => {
    return (
        <Route { ...rest }
            render={props => {
                return (<> <Component {...props} /> </>);
            }}
        />
    );
};

export { AuthProtected, AccessRoute }